import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-weight',
  templateUrl: './weight.component.svg',
  styleUrls: [],
})
export class WeightComponent extends MedrecordIcon {
  viewHeight: number = 24;
  viewWidth: number = 24;
}
